(function () {
    'use strict';

    angular.module("imApp").factory("p2StatSourceEditService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 808,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 809,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
